import axios, { type AxiosRequestConfig } from 'axios';

export const get = <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
  axios.get<T>(url, config).then((r) => r.data);

export const post = <T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<T> =>
  axios.post<T>(url, body, config).then((r) => r.data);

export const put = (url: string, body?: unknown, config?: AxiosRequestConfig): Promise<void> =>
  axios.put(url, body, config).then(() => undefined);

export const patch = (url: string, body?: unknown, config?: AxiosRequestConfig): Promise<void> =>
  axios.patch(url, body, config).then(() => undefined);

export const del = (url: string, config?: AxiosRequestConfig): Promise<void> =>
  axios.delete(url, config).then(() => undefined);
